import { useKeycloak } from '@react-keycloak/web'
import React from 'react'
import SplashScreen from './component/SplashScreen'
import Routes from './routes'

const App: React.FC = () => {
  const { initialized } = useKeycloak()

  if (!initialized) {
    return <SplashScreen />
  }

  return <Routes />
}

export default App
